/* eslint-disable filenames/match-regex */

import DateUtils from 'utils/DateUtils';
import Format from 'utils/Format';
export function renderHTMLBillBG (data) {
    const newDate = DateUtils.formatDayAndTimePicker(new Date()).split('/')[1];
    const _user = localStorage.getItem('Apec_Account');
    const user = _user && JSON.parse(_user).username;
    const columnOder = () => {
        let _column = '';
        const list = data?.itemsends && data.itemsends?.filter(e =>e?.ipaddress === data?.ipaddress);
        
        for(let i=0; i <list.length; i++) {
            _column += `<tr style="vertical-align:top;">
            <td style="width:0px;height:29px;"></td>
            <td class="csDA17CD4C" colspan="2" style="width:12px;height:23px;line-height:10px;text-align:left;vertical-align:middle;"><nobr>${i + 1}</nobr></td>
            <td class="csDA17CD4C" colspan="8" style="width:68px;height:12px;line-height:10px;text-align:left;vertical-align:middle; word-wrap: break-word; white-space: normal;">
            ${list[i]?.iname}
           </td>
            <td class="csDA17CD4C" colspan="2" style="width:20px;height:23px;line-height:10px;text-align:center;vertical-align:middle;"><nobr>${list[i].unit}</nobr></td>
            <td class="csDA17CD4C" colspan="6" style="width:22px;height:23px;line-height:10px;text-align:center;vertical-align:middle;"><nobr>${list[i].quanitity}</nobr></td>
            <td class="csDA17CD4C" colspan="4" style="width:46px;height:23px;line-height:10px;text-align:right;vertical-align:middle;"><nobr>${list[i].price}</nobr></td>
            <td class="csDA17CD4C" colspan="7" style="width:46px;height:23px;line-height:10px;text-align:right;vertical-align:middle;"><nobr>${Number(list[i]?.price  || 0) * Number(list[i]?.quanitity || 0)}</nobr></td>
        </tr>`;
        } 
        return _column;
    };

    const table = `<tr style="vertical-align:top;">
    <td style="width:0px;height:24px;"></td>
    <td class="cs4FADFF8F" colspan="2" style="width:16px;height:24px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>No</nobr></td>
    <td class="cs4FADFF8F" colspan="8" style="width:69px;height:24px;line-height:9px;text-align:center;vertical-align:middle;"><nobr>Item</nobr></td>
    <td class="cs4FADFF8F" colspan="2" style="width:24px;height:24px;line-height:9px;text-align:center;vertical-align:middle;"><nobr>Unit</nobr></td>
    <td class="cs4FADFF8F" colspan="6" style="width:26px;height:24px;line-height:9px;text-align:center;vertical-align:middle;"><nobr>Qty</nobr></td>
    <td class="cs4FADFF8F" colspan="4" style="width:45px;height:24px;line-height:9px;text-align:right;vertical-align:middle;"><nobr>Price</nobr></td>
    <td class="cs4B1904F1" colspan="7" style="width:51px;height:24px;line-height:9px;text-align:right;vertical-align:middle;"><nobr>Amount</nobr></td>
</tr>${columnOder()}`;


    return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <!-- saved from url=(0016)http://localhost -->
    <html>
    <head>
        <title>Document</title>
        <meta HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=utf-8"/>
        <style type="text/css">
            .cs4FADFF8F {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right:#FFFFFF 2px solid;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; }
            .cs4B1904F1 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right:transparent 1px solid;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; }
            .csC76BB281 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom:#000000 1px dashed;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-top:3px;padding-left:3px;padding-bottom:3px;}
            .csD5125DAB {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom:#000000 1px dashed;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-top:3px;padding-left:3px;padding-right:3px;padding-bottom:3px;}
            .cs8EA18762 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:normal; padding-left:2px;}
            .csFEAFFC4D {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:bold; font-style:normal; padding-left:2px;padding-right:2px;}
            .csD589D4E {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-left:2px;}
            .cs5F7AA6EF {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:11px; font-weight:normal; font-style:normal; padding-left:2px;padding-right:2px;}
            .csE6322FFC {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:12px; font-weight:bold; font-style:normal; padding-left:2px;padding-right:2px;}
            .cs6FC5B17 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:13px; font-weight:bold; font-style:normal; padding-left:2px;padding-right:2px;}
            .csA8DCAC4A {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:13px; font-weight:normal; font-style:normal; }
            .cs636938EA {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:italic; padding-left:2px;}
            .csA676D0BF {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; }
            .csB8BEB134 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; padding-left:1px;}
            .csADEC2D6F {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:bold; font-style:normal; padding-left:2px;}
            .cs5E2CCECE {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:italic; padding-left:2px;}
            .cs9FBDB683 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:italic; padding-left:2px;padding-right:2px;}
            .csABE5B009 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:italic; padding-left:3px;}
            .csB839DCA6 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-left:3px;}
            .cs27313B43 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-left:4px;}
            .cs9691FC92 {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-left:7px;}
            .cs693942EE {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-top:3px;padding-left:3px;padding-bottom:3px;}
            .csDA17CD4C {color:#000000;background-color:transparent;border-left-style: none;border-top-style: none;border-right-style: none;border-bottom-style: none;font-family:'Times New Roman'; font-size:9px; font-weight:normal; font-style:normal; padding-top:3px;padding-left:3px;padding-bottom:3px;}
            .csAC6A4475 {height:0px;width:0px;overflow:hidden;font-size:0px;line-height:0px;}
        </style>
    </head>
    
<body leftMargin=10 topMargin=10 rightMargin=10 bottomMargin=10  style="background-color: #FFFFFF; width: 330px; margin-top: 20px">
<table cellpadding="0" cellspacing="0" border="0" style="border-width:0px;empty-cells:show;width:242px;height:481px;position:relative;">
            <tr>
                <td style="width:0px;height:0px;"></td>
                <td style="height:0px;width:1px;"></td>
                <td style="height:0px;width:8px;"></td>
                <td style="height:0px;width:9px;"></td>
                <td style="height:0px;width:6px;"></td>
                <td style="height:0px;width:7px;"></td>
                <td style="height:0px;width:6px;"></td>
                <td style="height:0px;width:8px;"></td>
                <td style="height:0px;width:5px;"></td>
                <td style="height:0px;width:29px;"></td>
                <td style="height:0px;width:10px;"></td>
                <td style="height:0px;width:1px;"></td>
                <td style="height:0px;width:25px;"></td>
                <td style="height:0px;width:5px;"></td>
                <td style="height:0px;width:5px;"></td>
                <td style="height:0px;width:4px;"></td>
                <td style="height:0px;width:7px;"></td>
                <td style="height:0px;width:4px;"></td>
                <td style="height:0px;width:3px;"></td>
                <td style="height:0px;width:17px;"></td>
                <td style="height:0px;width:1px;"></td>
                <td style="height:0px;width:1px;"></td>
                <td style="height:0px;width:28px;"></td>
                <td style="height:0px;width:16px;"></td>
                <td style="height:0px;width:1px;"></td>
                <td style="height:0px;width:1px;"></td>
                <td style="height:0px;width:27px;"></td>
                <td style="height:0px;width:2px;"></td>
                <td style="height:0px;width:1px;"></td>
                <td style="height:0px;width:4px;"></td>
            </tr>
        <tr style="vertical-align:top;">
            <td class="csA676D0BF" colspan="26" style="width:229px;height:12px;line-height:10px;text-align:left;vertical-align:top;"><nobr>${data?.hotelDetail?.hotelName || ''}</nobr></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td class="csA676D0BF" colspan="24" style="width:36px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>Website: ${data?.hotelDetail.website || ''}</nobr></td>
            <td></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td class="csA676D0BF" colspan="24" style="width:22px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>Add: ${data?.hotelDetail.address || ''}</nobr></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:10px;"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td class="csA676D0BF" colspan="12" style="width:41px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>Tax&nbsp;code: ${data?.hotelDetail.taxCode || ''}</nobr></td>
            <td></td>
            <td></td>
            <td class="csA676D0BF" colspan="12" style="width:36px;height:13px;line-height:10px;text-align:left;vertical-align:top;"><nobr>Hotline: ${data?.hotelDetail.phone || ''}</nobr></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:2px;"></td>
        </tr>
        </tr>
        <tr style="vertical-align:top;">
        <td style="width:0px;height:10px;"></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
    </tr>
    <tr style="vertical-align:top;">
    <td colspan="27" style="height:1px; border-bottom: 1px dashed black;"></td>
</tr>
<tr style="vertical-align:top;">
<td style="width:0px;height:10px;"></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
</tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:22px;"></td>
            <td class="cs6FC5B17" colspan="29" style="width:238px;height:22px;line-height:15px;text-align:center;vertical-align:middle;"><nobr>Receipt</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:10px;"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td class="csADEC2D6F" colspan="12" style="width:22px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Date: ${data.orderTime}</nobr></td>
            <td class="csADEC2D6F" colspan="12" style="width:29px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Outlet: ${data.location}</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
            <td class="csADEC2D6F" colspan="12" style="width:29px;height:14px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Order: ${data.orderNo}</nobr></td>
            <td class="csADEC2D6F" colspan="12" style="width:29px;height:14px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Guest: ${data.totalGuest}</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:1px;"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
       ${table}
        <tr style="vertical-align:top;">
            <td style="width:0px;height:2px;"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:17px;"></td>
            <td class="cs8EA18762" colspan="9" style="width:87px;height:17px;line-height:12px;text-align:left;vertical-align:middle; border-top:#000000 1px dashed"><nobr>Total Amt</nobr></td>
            <td></td>
            <td class="csFEAFFC4D" colspan="14" style="width:112px;height:17px;line-height:12px;text-align:right;vertical-align:middle; border-top:#000000 1px dashed"><nobr>${Format.formatMoneyNotD(data?.totalAmount)} VND</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:17px;"></td>
            <td class="cs8EA18762" colspan="9" style="width:77px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Discount&nbsp;Amt&nbsp${data?.isDiscountPer === 'Y' ? `(${data?.discount}%)` : ''}</nobr></td>
            <td class="csFEAFFC4D" colspan="14" style="width:73px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.billDiscount)} VND</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
        <td style="width:0px;height:17px;"></td>
        <td class="cs8EA18762" colspan="9" style="width:77px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Sub&nbsp; Total</nobr></td>
        <td class="csFEAFFC4D" colspan="14" style="width:73px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.subTotal)} VND</nobr></td>
        <tr style="vertical-align:top;">
        <td style="width:0px;height:17px;"></td>
        <td class="cs8EA18762" colspan="9" style="width:77px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Service Charge:</nobr></td>
        <td class="csFEAFFC4D" colspan="14" style="width:73px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.serviceCharge)} VND</nobr></td>
    </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:16px;"></td>
            <td class="cs8EA18762" colspan="9" style="width:87px;height:16px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>VAT</nobr></td>
            <td class="csFEAFFC4D" colspan="14" style="width:113px;height:16px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.tax)} VND</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:17px;"></td>
            <td class="cs8EA18762" colspan="9" style="width:87px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>TTDB</nobr></td>
            <td></td>
            <td class="csFEAFFC4D" colspan="14" style="width:113px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.ttdb)} VND</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:17px;"></td>
            <td class="cs8EA18762" colspan="9" style="width:87px;height:16px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Total:</nobr></td>
            <td class="csFEAFFC4D" colspan="14" style="width:114px;height:16px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.total)} VND</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:8px;"></td>
           
        </tr>
        <tr style="vertical-align:top;">
        <td colspan="27" style="height:1px; border-bottom: 1px dashed black;"></td>
    </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:16px;"></td>
            <td class="csD589D4E" colspan="9" style="width:87px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Amount&nbsp;paid</nobr></td>
            <td class="cs5F7AA6EF" colspan="14" style="width:113px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.amountPaid)} VND</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
        <td style="width:0px;height:16px;"></td>
        <td class="csD589D4E" colspan="9" style="width:87px;height:17px;line-height:12px;text-align:left;vertical-align:middle;"><nobr>Due&nbsp;back</nobr></td>
        <td class="cs5F7AA6EF" colspan="14" style="width:113px;height:17px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${Format.formatMoneyNotD(data.dueBack)} VND</nobr></td>
    </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:15px;"></td>
            <td class="csD589D4E" colspan="9" rowspan="3" style="width:86px;height:16px;line-height:12px;text-align:left;vertical-align:middle; "><nobr>Payment method</nobr></td>
            <td class="cs5F7AA6EF" colspan="14" rowspan="3" style="width:114px;height:16px;line-height:12px;text-align:right;vertical-align:middle;"><nobr>${data?.paymentMethod || ''}</nobr></td>
        </tr>
        </tr>
 
    </tr>
    
        <tr style="vertical-align:top;">
            <td style="width:0px;height:1px;"></td>
            <td></td>
            <td class="csD589D4E" colspan="19" rowspan="4" style="width:151px;height:17px;"><!--[if lte IE 7]><div class="csAC6A4475"></div><![endif]--></td>
        </tr>
  <tr style="vertical-align:top;">
            <td style="width:0px;height:1px;"></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
        <td style="width:0px;height:15px;"></td>
        <td></td>
    </tr>
 
        <tr style="vertical-align:top;">
            <td style="width:0px;height:1px;"></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:14px;"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
        <td style="width:0px;height:16px;"></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td colspan="18"> <img src=${data?.img} alt="Mô tả ảnh" width="200"></td>
        <td>
        </td>
        <td></td>
        <td></td>
    </tr>
    <tr style="vertical-align:top;">
    <td style="width:0px;height:6px;"></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
</tr>
<tr style="vertical-align:top;">
<td style="width:0px;height:6px;"></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
</tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:16px;"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            
            <td class="csE6322FFC" colspan="10" style="width:95px;height:16px;line-height:13px;text-align:center;vertical-align:top;"><nobr>Guest&nbsp;signature</nobr></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:46px;"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:8px;"></td>
            <td class="cs9FBDB683" colspan="29" rowspan="2" style="width:238px;height:14px;line-height:10px;text-align:center;vertical-align:top;"><nobr>Thank&nbsp;you&nbsp;and&nbsp;See&nbsp;you&nbsp;again!</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
           <td colspan="27" style="height:1px; border-bottom: 1px dashed black;"></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:1px;"></td>
        </tr>
        <tr style="vertical-align:top;">
        <td style="width:0px;height:8px;"></td>
       </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:3px;"></td>
            <td class="cs5E2CCECE" colspan="7" rowspan="2" style="width:43px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>Print&nbsp;date: ${newDate}</nobr></td>
            <td class="cs5E2CCECE" colspan="9" rowspan="2" style="width:45px;height:13px;line-height:9px;text-align:left;vertical-align:middle;"><nobr>-&nbsp;Staff:${user}</nobr></td>
        </tr>
        <tr style="vertical-align:top;">
            <td style="width:0px;height:10px;"></td>
        </tr>
    </table>
    </body>
    </html>
    `;
}
